import * as React from "react";
export var colorStatus = function colorStatus(polizaStatus) {
  switch (polizaStatus) {
    case "BORRADOR":
      return /*#__PURE__*/React.createElement("a", null, "\uD83D\uDFE1 ");

    case "VIGENTE":
      return /*#__PURE__*/React.createElement("a", null, "\uD83D\uDFE2 ");

    case "NO VIGENTE":
      return /*#__PURE__*/React.createElement("a", null, "\uD83D\uDD34 ");

    case "CANCELADA":
      return /*#__PURE__*/React.createElement("a", null, "\uD83D\uDD34 ");

    case "ANULADA":
      return /*#__PURE__*/React.createElement("a", null, "\uD83D\uDD34 ");

    default:
      return null;
  }
};